import { render } from "./ApiGuideAuthForm.vue?vue&type=template&id=4df5ba05&scoped=true"
import script from "./ApiGuideAuthForm.vue?vue&type=script&lang=js"
export * from "./ApiGuideAuthForm.vue?vue&type=script&lang=js"

import "./ApiGuideAuthForm.vue?vue&type=style&index=0&id=4df5ba05&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df5ba05"]])

export default __exports__